
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { PlusCircle, FileText } from "lucide-react";
import AdminLayout from "@/components/admin/AdminLayout";
import RecipeIdeasManager from "@/components/admin/tools/RecipeIdeasManager";
import { useAdminCheck } from "@/hooks/useAdminCheck";
import { db } from "@/integrations/cloudflare/client";

const RecipeGeneratorConfig = () => {
  const { isLoading: isAuthLoading } = useAdminCheck();
  const navigate = useNavigate();
  const [recipeCount, setRecipeCount] = useState<number>(0);
  const [isLoadingCount, setIsLoadingCount] = useState(true);

  useEffect(() => {
    const loadRecipeCount = async () => {
      try {
        const { count, error } = await db
          .from("holiday_recipes")
          .select("*", { count: "exact", head: true });
        
        if (error) throw error;
        setRecipeCount(count || 0);
      } catch (error) {
        console.error("Error loading recipe count:", error);
      } finally {
        setIsLoadingCount(false);
      }
    };

    loadRecipeCount();
  }, []);

  if (isAuthLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="animate-spin h-8 w-8 border-4 border-elfGreen border-t-transparent rounded-full mx-auto mb-4"></div>
          <p className="text-gray-700">Checking authentication...</p>
        </div>
      </div>
    );
  }

  return (
    <AdminLayout
      title="Recipe Generator Configuration"
      backLink="/admin/tools"
      backLabel="Back to Tools"
    >
      <div className="space-y-6">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <div>
            <h1 className="text-2xl font-bold">Recipe Generator</h1>
            <p className="text-gray-500">
              Manage holiday recipe ideas for the Recipe Generator tool
            </p>
          </div>
          <div className="flex gap-2">
            <Button
              variant="outline"
              onClick={() => navigate("/admin/tools/recipe-importer")}
              className="flex items-center gap-1"
            >
              <FileText size={16} />
              Import Recipes
            </Button>
            <Button
              onClick={() => navigate("/admin/tools/recipe-generator/new")}
              className="bg-elfGreen hover:bg-elfGreen-dark flex items-center gap-1"
            >
              <PlusCircle size={16} />
              Add New Recipe
            </Button>
          </div>
        </div>

        <RecipeIdeasManager />
      </div>
    </AdminLayout>
  );
};

export default RecipeGeneratorConfig;
